import { modalFunc, autoExpand, txtAutoExpand, getSelectedText } from './helper'
import Bvi from '../bvi/js/index'
import api from './api'
import IMask from 'imask'

// function checkVisuallyImpaired() {
//   const isVisuallyImpaired = localStorage.getItem('visually-impaired')

//   if (isVisuallyImpaired === 'true') {
//     document.documentElement.classList.add('visually-impaired');
//     const visuallyImpairedType = localStorage.getItem('visually-impaired-type')

//     if (visuallyImpairedType === 'enlarge-size-1') document.documentElement.classList.add('enlarge-size-1');
//     else if (visuallyImpairedType === 'enlarge-size-2') document.documentElement.classList.add('enlarge-size-2');
//     else if (visuallyImpairedType === 'enlarge-size-3') document.documentElement.classList.add('enlarge-size-3');
//     else document.documentElement.classList.add('enlarge-size-1');
//   }
// }

document.addEventListener('DOMContentLoaded', () => {
  // checkVisuallyImpaired()

  // const themeBtn = document.querySelector('.theme')
  // themeBtn.addEventListener('click', () => {
  //   document.documentElement.classList.toggle('visually-impaired')
  //   if (document.documentElement.classList.contains('visually-impaired')) localStorage.setItem('visually-impaired', 'true')
  //   else localStorage.setItem('visually-impaired', 'false')

  //   const visuallyImpairedType = localStorage.getItem('visually-impaired-type')
  //   if (visuallyImpairedType) {
  //     document.documentElement.classList.add(visuallyImpairedType)
  //   } else {
  //     document.documentElement.classList.add('enlarge-size-1')
  //     localStorage.setItem('visually-impaired-type', 'enlarge-size-1')
  //   }
  // })

  const sizeBtns = document.querySelectorAll('.enlarge-size')
  sizeBtns.forEach((e) => {
    e.addEventListener('click', () => {
      sizeBtns.forEach((item) => {
        document.documentElement.classList.remove(item.dataset.size)
      })
      const className = e.dataset.size
      document.documentElement.classList.add(className)
      localStorage.setItem('visually-impaired-type', className)
    })
  })

  const { activeFunc, closeFunc } = contactFormValidFunc()

  const { clearForm } = contactFormFunc({
    formId: '#contact-form',
    func: (data) => formSend(data, activeFunc)
  })

  modalFunc({
    activatorClass: '.feedback',
    closeBtnClass: '.contact-form__btn--close',
    targetClass: '.modal',
    activeClass: 'modal--active',
    openFunc: clearForm,
    closeFunc: closeFunc
  })

  document.querySelector('.back-link')?.addEventListener('click', () => {
    history.back()
  })

  mobileNavInit()

  txtAutoExpand('textarea.input__body')

  const element = document.querySelector('input[name=phone]')

  siteErrorHandler()

  const maskOptions = {
    mask: '+{7} (000) 000 00 00'
  }

  const mask = IMask(element, maskOptions)

  new Bvi({
    target: '.bvi-open',
    theme: 'white',
    fontFamily: 'arial',
    fontSize: 10,
    letterSpacing: 'normal',
    lineHeight: 'normal',
    images: false,
    reload: false,
    panelFixed: true,
    speech: true,
    builtElements: true,
  })
})

function mobileNavInit() {
  const mobileNavBody = document.querySelector('.mobile-nav__body')
  const mobileNavBtn = document.querySelector('.mobile-nav__btn')
  const mobileNavBtnClose = document.querySelector('.mobile-nav__close')

  mobileNavBtn.addEventListener('click', () => {
    mobileNavBody.classList.add('mobile-nav__body--active')
  })

  mobileNavBtnClose.addEventListener('click', () => {
    mobileNavBody.classList.remove('mobile-nav__body--active')
  })
}

function contactFormValidFunc() {
  const resultMsg = document.querySelector('.contact-form__msg')

  return {
    closeFunc: () => {
      resultMsg.classList.remove('contact-form__msg--active')
    },
    activeFunc: () => {
      resultMsg.classList.add('contact-form__msg--active')
    }
  }
}

function contactFormFunc({ formId, func }) {
  const form = document.querySelector(formId)

  if (!form) return

  function clearForm() {
    form.name.value = ''
    form.phone.value = ''
    form.theme.value = ''
    form.message.value = ''
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault()

    const formData = new FormData()
    formData.append('name', form.name.value)
    formData.append('topic', form.theme.value)
    formData.append('phone_number', form.phone.value)
    formData.append('description', form.message.value)
    func(formData)
  })

  return {
    clearForm
  }
}

async function formSend(formData, callback = () => { }, callbackError = () => { }) {
  try {
    const res = await api.post('/add/request', formData)

    if (res.status > 400) {
      callbackError()
    }

    callback()
  } catch (e) {
    callbackError()
  }
}

function siteErrorHandler() {
  document.addEventListener('keydown', (e) => {
    if (e.ctrlKey && e.key === 'Enter') {
      const selection = getSelectedText().toString()
      if (selection) {
        const form = document.querySelector('.modal')
        const formBody = document.querySelector('.modal form')

        if (!form || !formBody) return

        form.classList.add('modal--active')
        formBody.theme.value = JSON.parse(String(formBody.theme.dataset.themes))['error'] || ''
        formBody.message.value = selection
        autoExpand(formBody.message)
      }
    }
  })
}
